import { Directive, ElementRef, HostListener, HostBinding } from '@angular/core';

@Directive({
  selector: '[eosFileSizeLimit]'
})
export class FileSizeLimitDirective {

  @HostBinding('class.is-invalid') isInvalid = false;
  constructor(private el: ElementRef) {
  }

  @HostListener('change') onChange() {

    if (this.el.nativeElement.files[0].size > 10000000) {
      this.isInvalid = true;
    } else {
      this.isInvalid = false;
    }
  }

}
